import { Typography, OTP } from "mobily-ui-library/lib";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../context/GlobalContext";

import { getOTP, getOAuth } from '../../api/api';
import { uniqueID } from '../../util/uniqueID';
import Error from "../../components/Error/Error";

import RequestIcon from '../../assets/RequestCredit.svg';
import "./LoginOTP.scss";

const win: any = window;

type Props = {
  setSuccess: (flag: boolean) => void;
}

function LoginOTP({ setSuccess }: Props) {
  const { state, dispatch }: any = useContext(GlobalContext);
  const [otpValue, setOTPValue] = useState('');
  const [error, setError] = useState("");
  const [subError, setSubError] = useState("");
  const [second, setSecond] = useState(30);
  const uuid = uniqueID()

  const { t } = useTranslation();
  const { rtl, msisdn, otpToken, returnUrl, accountType } = state;

  useEffect(() => {
    let timer: any;
    if (second > 0) {
      timer = setTimeout(() => setSecond(second - 1), 1000);
    } else {
      setSecond(0);
    }

    return () => clearTimeout(timer)
  }, [second]);

  const handleSendAgain = () => {
    setSecond(30);
    setError("");
    setSubError("");
    dispatch({ type: "LOADER", payload: { loading: true } });
    const data = {
      "transactionId": uuid,
      "msisdnNumber": msisdn,
      "pinCode": "",
      "otpToken": "",
      "deviceInfo": {
        "requestDate": Date.now(),
        "lang": rtl ? "AR" : "EN",
        "device_id": "",
        "os_type": "",
        "os_version": "",
        "device_model": "",
        "app_id": "",
        "app_version": "",
        "ip_address": "",
        "mac_address": "",
        "latitude": "",
        "longitude": ""
      }
    }

    getOTP(data).then((res: any) => {
      if (res.data.status.statusCode === 'MBE_000') {
        setOTPValue("");
        dispatch({ type: "LOADER", payload: { loading: false } });
        dispatch({ type: "MSISDN", payload: { msisdn: msisdn, otpToken: res.data.otpToken } });
      } else {
        dispatch({ type: "LOADER", payload: { loading: false } });
        window.location = win['errorPageUrl'];
      }
    }).catch(() => {
      setTimeout(() => {
        window.location = win['errorPageUrl']
      }, 3000)
    })
  }

  const handleOtpChange = (value: any) => {
    const pattern = /^[0-9]{4}/;
    const result = pattern.test(value);
    if (value !== "") {
      if (result) {
        dispatch({ type: "LOADER", payload: { loading: true } });

        getOAuthToken(value);
        setOTPValue("");
      }
    }
    setOTPValue(value)
  }

  const getOAuthToken = (otpValue: any) => {
    const device_id = win['jsessionId'] === 'error' ? "94A73AE7-E117-46E2-8917-BA2A50E92166" : win['jsessionId'];
    const req = {
      "username": otpToken,
      "password": otpValue,
      "grant_type": "password",
      "app_id": "portal",
      "app_version": '1',
      "device_id": device_id,
      "os_type": "",
      "os_version": "",
      "device_model": "",
      "ip_address": "",
      "mac_address": "",
      "latitude": "",
      "longitude": "",
      "login_type": "otp",
      "lang": rtl ? "AR" : "EN",
      "clientId": win['CEM_KEY']
    }

    getOAuth(req)
      .then((res: any) => res.json())
      .then((data: any) => {
        if (data.access_token) {
          dispatch({ type: "LOADER", payload: { loading: false } });
          if (accountType === "ecommerceAbsher") {
            win.location = `${returnUrl}&easyLogin=success`;
          } else if (accountType === "chatbot") {
            setSuccess(true);
          } else {
            if (window.location.href.includes("localhost")) {
              win.location = `${returnUrl}?ut=${data.access_token}`;
            } else {
              localStorage.setItem('bill_at', data.access_token);
              win.location = `${returnUrl}`
            }
          }
        } else if (data.statusCode === "MBE_301") {
          dispatch({ type: "LOADER", payload: { loading: false } });
          setError(t("Invalid_code"));
          setSubError(t("Code_invalid"))
        } else if (data.statusCode === "MBE_475") {
          dispatch({ type: "LOADER", payload: { loading: false } });
          window.location = win['errorPageUrl'];
        } else {
          dispatch({ type: "LOADER", payload: { loading: false } });
          window.location = win['errorPageUrl'];
        }
      })
      .catch(() => {
        dispatch({ type: "LOADER", payload: { loading: false } });
        window.location = win['errorPageUrl'];
      })
  }

  const handleError = () => {
    setError("");
    setSubError("");
    setOTPValue('');
    if (second > 0) {
      setSecond(0);
    }
  }

  return (
    <>
      {(error && subError) && (
        <Error
          rtl={rtl}
          second={second}
          errorHeading={error}
          errorSubHeading={subError}
          handleErrorBtnClick={handleError}
          handleSendAgain={handleSendAgain}
        />
      )}
      <div className={rtl ? "container EasyLogin__allThePage EL_right" : "container EasyLogin__allThePage"}>
        <div className='row'>
          <div className="EL-text">
            <img className="theIcon" src={RequestIcon} alt="icon" />
            <Typography rtl={rtl} className="heading">{t("We_need_to_know")}</Typography>
            <Typography rtl={rtl} className="sub-heading">{t('OTP_send_to_you')} <span>{`+${msisdn}`}</span></Typography>
            <Typography rtl={rtl} className="sub-heading">{t('Enter_it_below')}</Typography>
          </div>

          <div className="theLine"></div>
          <div className="otp-container">
            <OTP
              className="otpClass"
              numInputs={4}
              value={otpValue}
              isDisabled={false}
              onChange={handleOtpChange}
            />
          </div>

          {second > 0 ? (
            <Typography rtl={rtl} className="otp-text" >
              {t("Request_new_code")}
              <span>{0}:{second < 10 ? `0${second}` : second}</span>
            </Typography>
          ) : (
            <Typography rtl={rtl} className="didnt_recieve">
              {t("Didnt_recieve_code")}
              <span onClick={handleSendAgain}>{t("Send_again")}</span>
            </Typography>
          )}
        </div>
      </div>
    </>
  );
}

export default LoginOTP;
